export default "__VITE_ASSET__MSZeQ7wd__"